import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

function ArtistList() {
    const [artists, setArtists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState('');

    useEffect(() => {
        axios.get(`${config.API_URL}/artists`)
            .then(res => {
                setArtists(res.data);
                setLoading(false);
            })
            .catch(err => {
                setError('Failed to load artists');
                setLoading(false);
            });
    }, []);

    const filtered = artists.filter(a =>
        a.name.toLowerCase().includes(search.toLowerCase()) ||
        (a.city && a.city.toLowerCase().includes(search.toLowerCase())) ||
        (a.state && a.state.toLowerCase().includes(search.toLowerCase()))
    );

    if (loading) return <div style={styles.message}>Loading artists...</div>;
    if (error) return <div style={styles.error}>{error}</div>;

    return (
        <div>
            <div style={styles.header}>
                <h1 style={styles.title}>Artists</h1>
                <Link to="/add-artist" style={styles.addButton}>+ Add Artist</Link>
            </div>

            <input
                type="text"
                placeholder="Search artists by name or location..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={styles.search}
            />

            {filtered.length === 0 ? (
                <div style={styles.message}>
                    {artists.length === 0 ? 'No artists yet. Add your first artist!' : 'No artists match your search.'}
                </div>
            ) : (
                <div style={styles.grid}>
                    {filtered.map(artist => (
                        <Link to={`/artists/${artist.slug || artist.id}`} key={artist.id} style={styles.card}>
                            <div style={styles.cardName}>{artist.name}</div>
                            <div style={styles.cardLocation}>
                                {[artist.city, artist.state, artist.country].filter(Boolean).join(', ')}
                            </div>
                            <div style={styles.cardMeta}>
                                {artist.artist_type && <span style={styles.tag}>{artist.artist_type}</span>}
                                {artist.artist_style && <span style={styles.tag}>{artist.artist_style}</span>}
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}

const styles = {
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
    },
    title: {
        fontSize: '32px',
        fontWeight: 'bold',
        color: '#e0e0e0',
    },
    addButton: {
        backgroundColor: '#bb86fc',
        color: '#121212',
        textDecoration: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        fontWeight: 'bold',
        fontSize: '14px',
    },
    search: {
        backgroundColor: '#2c2c2c',
        border: '1px solid #444',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '15px',
        color: '#e0e0e0',
        width: '100%',
        marginBottom: '24px',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '16px',
    },
    card: {
        backgroundColor: '#1e1e1e',
        border: '1px solid #333',
        borderRadius: '8px',
        padding: '20px',
        textDecoration: 'none',
        color: '#e0e0e0',
        display: 'block',
        transition: 'border-color 0.2s',
    },
    cardName: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '6px',
        color: '#e0e0e0',
    },
    cardLocation: {
        fontSize: '14px',
        color: '#aaa',
        marginBottom: '12px',
    },
    cardMeta: {
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
    },
    tag: {
        backgroundColor: '#2c2c2c',
        border: '1px solid #444',
        borderRadius: '4px',
        padding: '2px 8px',
        fontSize: '12px',
        color: '#bb86fc',
    },
    message: {
        textAlign: 'center',
        color: '#aaa',
        fontSize: '16px',
        padding: '60px 0',
    },
    error: {
        textAlign: 'center',
        color: '#cf6679',
        fontSize: '16px',
        padding: '60px 0',
    },
};

export default ArtistList;